import { APP_PERMISSIONS } from '@report/permission';
import { ReportMenuCardList } from '@report/report-menu-card-list';
import { Flex, Text } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ReportsPage() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.EXAM_EVENT_OVERVIEW_REPORT.VIEW,
        APP_PERMISSIONS.EXAM_COURSE_ANALYSIS_REPORT.VIEW,
        APP_PERMISSIONS.QBANK_ITEMS_ANALYSIS_REPORT.VIEW,
        APP_PERMISSIONS.QBANK_ITEMS_ANALYSIS_YEARLY_REPORT.VIEW,
        APP_PERMISSIONS.QSET_USAGE_STATUS_REPORT.VIEW,
        APP_PERMISSIONS.QUESTION_USAGE_BY_QSET_REPORT.VIEW,
        APP_PERMISSIONS.QUESTIONNAIRE_REPORT.VIEW,
      ]}
      options={{
        operator: 'OR',
      }}
    >
      <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
        <Flex
          component='header'
          sx={(theme) => ({
            flexDirection: 'column',
            p: theme.spacing(6, 7),
            gap: theme.spacing(0.5),
          })}
        >
          <Text variant='h1'>SET e-Exam Report Center</Text>
          <Text variant='h5' color='text.secondary'>
            ศูนย์รวมรายงานระบบ SET e-Exam
          </Text>
        </Flex>
        <Flex sx={(theme) => ({ p: theme.spacing(6), flexGrow: 1 })}>
          <ReportMenuCardList />
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
